import script from "./SingleFlightCardEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleFlightCardEdit.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__